import { bool, func, oneOf, string } from 'prop-types'
import { hypernovaIconNames } from '@opallabs/constellation'
import Conditional from '../../Conditional'
import CheckBox from '../../Inputs/CheckBox'
import { kuiperClassNames, renderIcon } from '../../utils'

import './styles.scss'

const iconSpan = (icon, onClick) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <span onClick={onClick} className={kuiperClassNames('control-icon', icon)}>
    {renderIcon(icon, { height: 9, width: 9 })}
  </span>
)

const expander = (onExpand) =>
  onExpand ? iconSpan('chevron-e', onExpand) : null

const getIcon = (iconName) => (hypernovaIconNames[iconName] ? iconName : 'file')
const getIconLabel = (iconName) => getIcon(iconName).split(/\W/)[0]

const reverser = (onReverse) => (
  <Conditional condition={!!onReverse}>
    {iconSpan('chevron-w', onReverse)}
  </Conditional>
)

const checkBox = (onCheckChange, checked) =>
  onCheckChange ? (
    <CheckBox
      disabled={false}
      value={checked}
      displayType="filechecker"
      onChange={onCheckChange}
    />
  ) : null

const FileListItem = ({
  checked,
  color,
  disabled,
  highlighted,
  icon,
  id,
  indented,
  onCheckChange,
  onClick,
  onExpand,
  onReverse,
  selected,
  title,
}) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    key={id}
    className={kuiperClassNames('file-list-item', {
      expandable: onExpand,
      reversible: onReverse,
      clickable: onClick,
      checkable: onCheckChange,
      disabled,
      highlighted,
      indented,
      selected,
    })}
    onClick={onClick}
  >
    {reverser(onReverse)}
    {checkBox(onCheckChange ? onCheckChange.bind(null, id) : null, checked)}

    <span className={kuiperClassNames('title')}>
      <span
        className={kuiperClassNames('file-list-item-icon', {
          [`fg-color-${color}`]: color,
          'no-color': !color,
        })}
        style={{
          fill: color,
          color,
        }}
      >
        {renderIcon(getIcon(icon), {
          height: 14,
          width: 14,
          ariaLabel: `${getIconLabel(icon)}`,
          ariaMode: 'presentational',
        })}
      </span>
      <span className={kuiperClassNames('title-text')}>{title}</span>
    </span>

    <div className={kuiperClassNames('spacer')} />
    {expander(onExpand)}
  </div>
)

FileListItem.propTypes = {
  checked: oneOf([false, true, 'none', 'some', 'all']),
  color: string,
  disabled: bool,
  highlighted: bool,
  icon: string,
  id: string,
  indented: bool,
  onCheckChange: func,
  onClick: func,
  onExpand: func,
  onReverse: func,
  selected: bool,
  title: string,
}

FileListItem.defaultProps = {
  checked: 'none',
}

export default FileListItem
